import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { MobiUiIconComponent } from '@mobi/rwc-ui-components-ng-jslib';
import { TranslatePipe } from '@mobi/rwc-utils-ng-jslib';

@Component({
    selector: 'oiv-viewer-stacked-container',
    imports: [TranslatePipe, MobiUiIconComponent],
    templateUrl: './stacked-container.component.html',
    styleUrl: './stacked-container.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StackedContainerComponent {
    @Input() title = '';
    @Input() link = '';

    openRedirect() {
        if (this.link) window.open(this.link, '_self');
    }
}
